import {Prescription} from 'types';
import styles from './EditModal.module.scss';
import Modal from 'components/Modal';
import Typography from 'components/Typography';
import {useEditModal} from './useEditModal';
import {Fragment} from 'react/jsx-runtime';
import {NewProduct} from 'pages/Products/Products';
import {useState} from 'react';
import Button from 'components/Button';
import CreatableSelect from 'components/CreatableSelect';
import toast from 'react-hot-toast';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  product?: Prescription | Prescription[];
  refetch: () => void;
  requestId: number;
  editType: 'service' | 'product' | 'none';
  otherTypeCount: number;
}

function EditModal({
  isOpen,
  onClose,
  product,
  refetch: refetchOrder,
  requestId,
  editType,
  otherTypeCount,
}: Props) {
  const {
    productList,
    serviceList,
    isLoading,
    refetchOptions,
    updateRequestProducts,
    setItemIds,
    itemIds,
    error,
    sharedDefaultValue,
    setSharedDefaultValue,
  } = useEditModal({
    isOpen,
    requestId,
    type: editType === 'product' ? 'product' : 'service',
    product,
    refetchOrder,
    onClose,
  });
  const [addNewModalType, setAddNewModalType] = useState<
    'product' | 'service' | 'none'
  >('none');

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        onRequestClose={onClose}
        showCloseButton={true}
        className={styles.list_wrapper}
      >
        <Typography variant="h2">Edit {editType}</Typography>

        {editType === 'service' && (
          <Fragment>
            <div className={styles.label}>
              <div>Service</div>
            </div>
            <CreatableSelect
              placeholder="Search For Service"
              components={{
                DropdownIndicator: () => null,
              }}
              menuPosition="fixed"
              isLoading={isLoading}
              onCreateOption={(inputValue: string) => {
                setAddNewModalType('service');
                setSharedDefaultValue(inputValue);
              }}
              onChange={(item) => {
                if (Array.isArray(item)) {
                  setItemIds(item.map((item) => item.value));
                }
              }}
              value={
                itemIds.length > 0
                  ? serviceList
                      ?.filter((item) => itemIds.includes(Number(item.value)))
                      .map((item) => ({
                        value: Number(item.value),
                        label: item.label,
                      }))
                  : undefined
              }
              // @ts-ignore
              isMulti={true}
              isSearchable={true}
              options={serviceList}
            />
            {error && (
              <div style={{color: 'red', marginTop: '8px', fontSize: '14px'}}>
                {error}
              </div>
            )}
          </Fragment>
        )}

        {editType === 'product' && (
          <Fragment>
            <div className={styles.label}>
              <div>Product</div>
            </div>
            <CreatableSelect
              placeholder="Search For Product"
              components={{
                DropdownIndicator: () => null,
              }}
              menuPosition="fixed"
              onChange={(item) => {
                if (Array.isArray(item)) {
                  setItemIds(item.map((item) => item.value));
                }
              }}
              onCreateOption={(inputValue: string) => {
                setAddNewModalType('product');
                setSharedDefaultValue(inputValue);
              }}
              value={
                itemIds.length > 0
                  ? productList
                      ?.filter((item) => itemIds.includes(Number(item.value)))
                      .map((item) => ({
                        value: item.value,
                        label: item.label,
                      }))
                  : undefined
              }
              isSearchable={true}
              // @ts-ignore
              isMulti={true}
              isLoading={isLoading}
              options={productList}
            />
          </Fragment>
        )}
        <div className={styles.button_container}>
          <Button
            color="blue"
            size="md"
            loading={updateRequestProducts.isLoading}
            onClick={() => {
              if (itemIds.length === 0 && otherTypeCount === 0) {
                toast.error('Order must have at least one product');
                return;
              }
              updateRequestProducts.mutate();
            }}
          >
            Save
          </Button>
        </div>
      </Modal>
      <NewProduct
        isTypeDisabled
        productType={addNewModalType === 'product' ? 'product' : 'service'}
        visible={addNewModalType !== 'none'}
        onClose={() => setAddNewModalType('none')}
        sharedDefaultValue={sharedDefaultValue}
        onSuccess={() => {
          setAddNewModalType('none');
          refetchOptions();
        }}
      />
    </>
  );
}
export default EditModal;
